import { globalInit } from '@/global';
import register from '@/components';
import { cl, hmr } from '@/utils';
import { barbaInit } from '@/barba';
import { default as initAnimations } from '@/animations';

// @ts-ignore
hmr();

(function (doc) {
  globalInit();
  register();
  barbaInit();
  initAnimations();

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    window.location.reload();
  })

  doc.addEventListener('DOMContentLoaded', () => {
    doc.fonts.ready.then(() => {
      cl(document.documentElement).remove('to-load');
    });
  });

  if (window.sentryOn) {
    import('@/utils/sentry').then((module) => {
      if (!module) return;
      const { default: SentryInit } = module;
      SentryInit({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        maxBreadcrumbs: 50,
        release: 'frontend'
      });
    });
  }

  import('@/htmx').then();
})(document);
